const navItems = [
    { name: "HOME", link: "home" },
    { name: "SKILLS", link: "skills" },
    { name: "PROJECTS", link: "projects" },
    { name: "EXPERIENCE", link: "experience" },
    { name: "CONTACT", link: "contact" },
  ];

export default navItems;
